import { TourDefinition } from '../models/guided-tour.models';

export const TOOLBAR_OVERVIEW_TOUR: TourDefinition = {
    id: 'toolbar-overview',
    label: 'Toolbar Overview',
    steps: [
        {
            element: '.toolbar-tour-step-1-js',
            data: { title: 'Main Navigation', description: 'Use these menus to access Sales, Rentals, and Buildings tools including search and resources.' },
            side: 'bottom',
            align: 'start',
        },
        {
            element: '.toolbar-tour-step-2-js',
            data: { title: 'Notifications', description: 'Stay up to date — new activity, matches, and alerts appear here.' },
            side: 'bottom',
            align: 'end',
        },
        {
            element: '.toolbar-tour-step-3-js',
            data: { title: 'Your Profile', description: 'Access account settings, theme preferences, and sign out from your profile menu.' },
            side: 'bottom',
            align: 'end',
        },
    ],
};
